// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"066c6f3d","419":"332c3702","563":"8f03286b","942":"7104c919"}[chunkId] + ".chunk.js";
};